module.exports = __webpack_public_path__ + "media/images/OtherMaterials-15cc9e45d6cd2e6082dc1c286ddf0051.svg";